import {Component, NgZone, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {Settings} from '@orga-app/settings/settings.model';
import {AlertController, LoadingController, ModalController, NavController, ToastController} from '@ionic/angular';
import {getTheme} from '@orga-app/settings/reducer';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import * as actionsUi from './qs-checks-controlling-veranstaltung.actions.ui';
import {
    getAktuellenPrueflauf, getAktuellePruefaufgabe, getPrueflaufDetail, getPrueflaufDetailFehler, getPrueflaufDetailLaden, getPrueflaufDetailListe,
    getVeranstaltungUebersicht, getVeranstaltungUebersichtFehler,
    getVeranstaltungUebersichtLaden, getVeranstaltungUebersichtListe
} from './qs-checks-controlling-veranstaltung.selectors';
import {of, Subject, Subscription} from 'rxjs';
import { Router } from '@angular/router';
import {Prueflauf, PrueflaufAntwort, PrueflaufAufgabe, PrueflaufCheckliste, PrueflaufDetail, VeranstaltungUebersicht} from '../../../../clients/qschecks';
import {PageState} from './qs-checks-controlling-veranstaltung.reducer';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {BildInfo} from '../../../shared/models/bildInfo';
import {catchError, filter, takeUntil, takeWhile} from 'rxjs/operators';
import {ResponseContentType} from '@angular/http';
import {ImageService} from '@orga-app/providers/image.service';
import {BildVorschauComponent} from '../../../../sopi/components/bild-vorschau/bild-vorschau';
import {AktuellenPrueflaufEntfernenAction, AufgabeBemerkungSpeichernAction, PruefaufgabeKorrigierenAction} from './qs-checks-controlling-veranstaltung.actions.ui';

@Component({
    selector: 'qs-checks-controlling-veranstaltung',
    templateUrl: 'qs-checks-controlling-veranstaltung.page.html',
    styleUrls: ['./qs-checks-controlling-veranstaltung.scss'],
})

export class QsChecksControllingVeranstaltungPage implements OnInit {
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;

    veranstaltungUebersicht$: Observable<VeranstaltungUebersicht>;
    veranstaltungUebersichtListe$: Observable<Array<ListInputItem>>;
    veranstaltungUebersichtLaden$: Observable<boolean>;
    veranstaltungUebersichtFehler$: Observable<boolean>;

    selectedPrueflauf$: Observable<Prueflauf>;

    prueflaufDetail$: Observable<PrueflaufDetail>;
    prueflaufDetailListe$: Observable<Array<ListInputItem>>;
    prueflaufDetailLaden$: Observable<boolean>;
    prueflaufDetailFehler$: Observable<boolean>;

    selectedPruefaufgabe$: Observable<PrueflaufAufgabe>;

    private bilder: Array<BildInfo> = new Array<BildInfo>();
    bilder$: Observable<BildInfo[]>;
    getPruefaufgabe$: Subscription;

    unsubscibe$ = new Subject<void>();
    private alive = true;

    public heute: Date;
    bemerkungText = '';

    constructor(public domSanitizer: DomSanitizer,
                public navCtrl: NavController,
                private store: Store<PageState>,
                public settingsProvider: SettingsProvider,
                private zone: NgZone,
                public loadingCtrl: LoadingController,
                private router: Router,
                private alertCtrl: AlertController,
                private modalCtrl: ModalController,
                private toastCtrl: ToastController,
                private imageService: ImageService
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));

        this.veranstaltungUebersicht$ = this.store.pipe(select(getVeranstaltungUebersicht));
        this.veranstaltungUebersichtListe$ = this.store.pipe(select(getVeranstaltungUebersichtListe));
        this.veranstaltungUebersichtLaden$ = this.store.pipe(select(getVeranstaltungUebersichtLaden));
        this.veranstaltungUebersichtFehler$ = this.store.pipe(select(getVeranstaltungUebersichtFehler));

        this.selectedPrueflauf$ = this.store.pipe(select(getAktuellenPrueflauf));

        this.prueflaufDetailListe$ = this.store.pipe(select(getPrueflaufDetailListe));

        this.prueflaufDetail$ = this.store.pipe(select(getPrueflaufDetail));
        this.prueflaufDetailLaden$ = this.store.pipe(select(getPrueflaufDetailLaden));
        this.prueflaufDetailFehler$ = this.store.pipe(select(getPrueflaufDetailFehler));

        this.selectedPruefaufgabe$ = this.store.pipe(select(getAktuellePruefaufgabe));
    }

    ngOnInit() {

    }

    ionViewWillEnter() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
        this.heute = new Date();

        this.unsubscibe$ = new Subject<void>();

        this.getPruefaufgabe$ = this.store.pipe(select(getAktuellePruefaufgabe), takeUntil(this.unsubscibe$)).subscribe((x: PrueflaufAufgabe) => {
            this.bilder = [];
            this.bilder$ = of(this.bilder);


            this.bemerkungText = '';

            if (x !== null && x.bemerkung !== null && x.bemerkung.length > 0) {
                this.bemerkungText = x.bemerkung;
            }

            let prueflaufDetail: PrueflaufDetail;
            this.prueflaufDetail$.subscribe(detail => prueflaufDetail = detail).unsubscribe();

            if (x != null && x.bild_ids !== null && x.bild_ids !== undefined && x.bild_ids.length > 0) {
                this.bemerkungText = x.bemerkung;
                x.bild_ids.forEach(bildId => {
                    this.getBild(prueflaufDetail.prueflauf_id, x.pruefaufgabe_id, bildId)
                        .pipe(
                            // tap(y => console.debug(y)),
                            takeWhile(() => this.alive)
                            , filter(image => {
                                return !!image;
                            }),
                            catchError((error: any) => {
                                console.debug('ERROR :: ', error);
                                return of();
                            }),
                        )
                        .subscribe((image: BlobPart) => {
                                const imgtype = bildId.split('.')[1];
                                if (image) {
                                    const blob = new Blob([image]);

                                    const reader = new FileReader();
                                    reader.onload = function () {
                                        const readerResult = reader.result.toString().replace('application/octet-stream', 'image/jpeg');
                                        const imgBase64JPEG = 'data:image/' + imgtype + ';base64,' + readerResult.split('base64,')[1];
                                        const bi = <BildInfo>{
                                            bildId,
                                            data: imgBase64JPEG,
                                            dataTrusted: this.domSanitizer.bypassSecurityTrustUrl(imgBase64JPEG),
                                            type: 'image/' + imgtype
                                        };

                                        this.zone.run(() => {
                                            if (this.bilder.findIndex(y => y.bildId === bi.bildId) === -1) {
                                                this.bilder.push(bi);
                                                // this.bilder.forEach(bild => {
                                                //     // console.log('Bilder: ', bild.data);
                                                // });
                                                this.bilder$ = of(this.bilder);
                                            }
                                        });

                                    }.bind(this);

                                    reader.readAsDataURL(blob);
                                }
                            },
                            error => {

                            });
                });
            }
        });
    }

    ionViewWillLeave() {
        this.unsubscibe$.next();
        this.unsubscibe$.complete();
    }

    uebersichtLaden() {
        this.store.dispatch(new actionsUi.VeranstaltungUebersichtNeuLadenAction());
    }

    prueflaufAuswaehlen(prueflauf: Prueflauf) {
        this.store.dispatch(new actionsUi.AktuellenPrueflaufSetzenAction(prueflauf));
    }

    pruefaufgabeAuswaehlen(pruefaufgabe: PrueflaufAufgabe) {
        this.store.dispatch(new actionsUi.AktuellePruefaufgabeSetzenAction(pruefaufgabe));
    }

    trackByAufgaben(index: number, aufgabe: PrueflaufAufgabe) {
        return aufgabe.modified_on_utc;
    }

    trackByChecklisten(index: number, aufgabe: PrueflaufCheckliste) {
        return aufgabe.modified_on_utc;
    }

    trackByAntworten(index: number, antwort: PrueflaufAntwort) {
        return antwort.antwort_id;
    }

    back() {
        setTimeout(async function () {
            await this.router.navigate(['/qschecks-controlling'], {
                relativeTo: this.route
            });
        }.bind(this), 500);
    }

    prueflaufDetailLaden() {
        this.store.dispatch(new actionsUi.PrueflaufDetailNeuLaden());
    }

    getBild(pruefId: string, aufgabeId: string, bildId: string, width: number = 400,  height: number = 400): Observable<any> {
      
        return this.imageService.getPruefungsaufgabeBildWithHttpInfo(pruefId, aufgabeId, bildId, width, height);
    }

    async bilderAnzeigen(index) {
        const imageModal = await this.modalCtrl.create({
            component: BildVorschauComponent,
            componentProps: {
                bilder: this.bilder$,
                initialImage: index
            }
        });
        imageModal.onDidDismiss().then(data => console.debug('QsChecksControllingVeranstaltungPage:: bilderAnzeigen :  imageModal.onDidDismiss: ' + data));
        await imageModal.present();
    }

    antwortKorrekturSetzen(aufgabe: PrueflaufAufgabe, antwort: PrueflaufAntwort) {
        this.store.dispatch(new PruefaufgabeKorrigierenAction(aufgabe, antwort));
    }

    aufgabeBemerkungSetzen() {
        this.store.dispatch(new AufgabeBemerkungSpeichernAction(this.bemerkungText));
    }

    async entfernePrueflauf() {
        const promptAlert = await this.alertCtrl.create({
            header: 'ACHTUNG',
            message: 'Gelöschte Prüfläufe werden in den Statistiken nicht mehr berücksichtigt. Willst du fortfahren?',
            buttons: [
                {
                    text: 'Ja',
                    handler: () => {
                        this.store.dispatch(new AktuellenPrueflaufEntfernenAction());
                    }
                },
                {
                    text: 'Abbrechen',
                    handler: () => {
                    }
                }
            ],
            cssClass: 'alertCustomCss'
        });
        await promptAlert.present();
    }
}
